module.exports = __webpack_public_path__ + "img/tipoEgresos.7797d191.svg";